/* ============================================================
   RISEBELT — Theme JS (Performance-Optimized)
   - FAQ accordion
   - Countdown timer
   - Sticky mobile CTA
   - Scroll reveal
   - AJAX add to cart
   - Cart count update
   - Product image gallery (consolidated — replaces inline section scripts)
   - Newsletter form
   - Section video lazy-load
   ============================================================ */

(function () {
  'use strict';

  /* ── FAQ Accordion ── */
  function initFAQ() {
    document.querySelectorAll('.faq-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ── Countdown Timer ── */
  function initCountdown() {
    var endKey = 'risebelt_countdown_end';
    var stored = localStorage.getItem(endKey);
    var end;

    if (stored) {
      end = new Date(parseInt(stored, 10));
      if (end < new Date()) {
        end = new Date();
        end.setDate(end.getDate() + 2);
        end.setHours(end.getHours() + 14);
        end.setMinutes(end.getMinutes() + 37);
        end.setSeconds(end.getSeconds() + 52);
        localStorage.setItem(endKey, end.getTime().toString());
      }
    } else {
      end = new Date();
      end.setDate(end.getDate() + 2);
      end.setHours(end.getHours() + 14);
      end.setMinutes(end.getMinutes() + 37);
      end.setSeconds(end.getSeconds() + 52);
      localStorage.setItem(endKey, end.getTime().toString());
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var diff = end - new Date();
      if (diff <= 0) { diff = 0; }
      var d = Math.floor(diff / (1000 * 60 * 60 * 24));
      var h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var m = Math.floor((diff / (1000 * 60)) % 60);
      var s = Math.floor((diff / 1000) % 60);
      var vals = [d, h, m, s];
      ['t-d', 't-h', 't-m', 't-s', 'cd-d', 'cd-h', 'cd-m', 'cd-s'].forEach(function (id, i) {
        var el = document.getElementById(id);
        if (el) el.textContent = pad(vals[i % 4]);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ── Mobile Menu ── */
  function initMobileMenu() {
    var toggle = document.querySelector('.menu-toggle');
    var mobileNav = document.getElementById('mobile-nav');
    if (!toggle || !mobileNav) return;
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      mobileNav.classList.toggle('open');
      mobileNav.setAttribute('aria-hidden', String(isOpen));
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        toggle.setAttribute('aria-expanded', 'false');
        mobileNav.classList.remove('open');
        mobileNav.setAttribute('aria-hidden', 'true');
      });
    });
  }

  /* ── Sticky Header Shadow ── */
  function initStickyHeader() {
    var header = document.querySelector('.header');
    if (!header) return;
    var threshold = 10;
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > threshold);
    }, { passive: true });
  }

  /* ── Sticky CTA (caches hero height to avoid forced layout on scroll) ── */
  function initStickyCTA() {
    var sticky = document.getElementById('sticky');
    var hero = document.querySelector('.hero');
    if (!sticky || !hero) return;

    var heroH = hero.offsetHeight;
    window.addEventListener('resize', function () { heroH = hero.offsetHeight; }, { passive: true });

    window.addEventListener('scroll', function () {
      sticky.classList.toggle('visible', window.scrollY > heroH);
    }, { passive: true });
  }

  /* ── Scroll Reveal ── */
  function initReveal() {
    if (!window.IntersectionObserver) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── Cart Notification ── */
  function showCartNotification(title) {
    var existing = document.querySelector('.cart-notification');
    if (existing) existing.remove();

    var note = document.createElement('div');
    note.className = 'cart-notification';
    note.innerHTML = '<strong>Ajouté au panier ✓</strong>' + (title || 'Kit Glute 30');
    document.body.appendChild(note);

    setTimeout(function () { note.classList.add('show'); }, 50);
    setTimeout(function () {
      note.classList.remove('show');
      setTimeout(function () { note.remove(); }, 400);
    }, 3500);
  }

  /* ── Update Cart Count ── */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  /* ── Fetch Cart ── */
  function fetchCart() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ── AJAX Add to Cart (fixed originalHTML scope bug) ── */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form], #product-form, .product-form');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"], .btn-primary');
      var originalHTML = btn ? btn.innerHTML : '';
      if (btn) btn.classList.add('loading');

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          fetchCart();
          showCartNotification(item.title);
          if (btn) {
            btn.classList.remove('loading');
            btn.innerHTML = originalHTML;
          }
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          if (btn) {
            btn.classList.remove('loading');
            btn.innerHTML = originalHTML || 'Recevoir mon kit';
          }
        });
    });
  }

  /* ── Offer section direct Add to Cart (non-form CTA) ── */
  function initOfferCTA() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId || btn.dataset.addToCart;
        if (!variantId) return;

        var originalHTML = btn.innerHTML;
        btn.classList.add('loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            fetchCart();
            showCartNotification(item.title);
            btn.classList.remove('loading');
            btn.innerHTML = originalHTML;
          })
          .catch(function () {
            btn.classList.remove('loading');
            btn.innerHTML = originalHTML;
          });
      });
    });
  }

  /* ── Product Image Gallery (simple fallback — superseded by initGalleryStacks) ── */
  function initGallery() {
    var mainImg = document.querySelector('.product-main-img img');
    if (!mainImg) return;

    document.querySelectorAll('.product-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src || thumb.querySelector('img').src;
        mainImg.src = src;
        document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ── Variant Selection ── */
  function initVariants() {
    var variantBtns = document.querySelectorAll('.variant-btn');
    if (!variantBtns.length) return;

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('sold-out')) return;
        var group = btn.closest('.variant-options');
        if (group) group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');

        var variantId = btn.dataset.variantId;
        var price = btn.dataset.price;

        if (variantId) {
          document.querySelectorAll('[name="id"]').forEach(function (input) { input.value = variantId; });
          document.querySelectorAll('[data-add-to-cart]').forEach(function (el) { el.dataset.variantId = variantId; });
        }
        if (price) {
          var priceEl = document.querySelector('.product-price');
          if (priceEl) priceEl.textContent = price;
        }
      });
    });
  }

  /* ── Newsletter Form ── */
  function initNewsletter() {
    document.querySelectorAll('.newsletter-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('.newsletter-input');
        var btn = form.querySelector('.newsletter-btn');
        var success = form.querySelector('.newsletter-success');

        if (!form.action || form.action.indexOf('contact') !== -1) return;

        e.preventDefault();
        if (btn) btn.textContent = '✓ Inscrite';
        if (input) input.value = '';
        if (success) success.classList.add('visible');
      });
    });
  }

  /* ── Smooth scroll for in-page anchors ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Cart page quantity update ── */
  function initCartPage() {
    var cartForm = document.querySelector('.cart-form');
    if (!cartForm) return;

    cartForm.querySelectorAll('.cart-qty input').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = input.dataset.line;
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () {});
      });
    });
  }

  /* ── Gallery Stack — universal init, replaces ALL inline section gallery scripts ──
     Works for .offer-gstack (homepage) and .prod-gstack (product page).
     Mobile: swipe + thumb navigation.
     Desktop: click non-main image to swap with main. ── */
  function initGalleryStacks() {
    var activeNavigate = null;

    document.querySelectorAll('.gallery-stack').forEach(function (wrap) {
      var itemsEl   = wrap.querySelector('.gs-items');
      var mThumbs   = Array.from(wrap.querySelectorAll('.gs-mobile-thumb'));
      var prevBtn   = wrap.querySelector('.gs-prev');
      var nextBtn   = wrap.querySelector('.gs-next');
      var counterEl = wrap.querySelector('.gs-counter span');
      var total     = wrap.querySelectorAll('.gs-item').length;
      var current   = 0;
      if (!itemsEl || total === 0) return;

      function isMobile() { return window.innerWidth <= 900; }

      function slideWidth() {
        var vp = wrap.querySelector('.gs-viewport');
        return vp ? vp.offsetWidth : wrap.offsetWidth;
      }

      function goTo(idx) {
        if (!isMobile()) return;
        current = ((idx % total) + total) % total;
        itemsEl.style.transform = 'translateX(-' + (current * slideWidth()) + 'px)';
        if (counterEl) counterEl.textContent = current + 1;
        mThumbs.forEach(function (t, i) {
          t.classList.toggle('active', i === current);
          if (i === current) {
            t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      }

      /* Navigate relative to current position — used by keyboard */
      function navigate(delta) { goTo(current + delta); }
      function activate() { activeNavigate = navigate; }

      wrap.addEventListener('mousedown', activate, { passive: true });
      wrap.addEventListener('touchstart', activate, { passive: true });

      mThumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(); goTo(i); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { activate(); goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { activate(); goTo(current + 1); });

      /* Touch swipe */
      var tx = 0, ty = 0, sw = false;
      itemsEl.addEventListener('touchstart', function (e) {
        if (!isMobile()) return;
        tx = e.touches[0].clientX; ty = e.touches[0].clientY; sw = true;
      }, { passive: true });
      itemsEl.addEventListener('touchmove', function (e) {
        if (!sw || !isMobile()) return;
        if (Math.abs(e.touches[0].clientX - tx) > Math.abs(e.touches[0].clientY - ty) + 8) {
          e.preventDefault();
        }
      }, { passive: false });
      itemsEl.addEventListener('touchend', function (e) {
        if (!sw || !isMobile()) return;
        sw = false;
        var d = tx - e.changedTouches[0].clientX;
        if (Math.abs(d) > 38) goTo(d > 0 ? current + 1 : current - 1);
      }, { passive: true });

      /* Resize — recalculate position */
      window.addEventListener('resize', function () {
        if (!isMobile()) { itemsEl.style.transform = ''; current = 0; }
        else { itemsEl.style.transform = 'translateX(-' + (current * slideWidth()) + 'px)'; }
      });

      /* Desktop: click non-main item → swap images with main slot */
      var allItems = Array.from(wrap.querySelectorAll('.gs-item'));
      allItems.forEach(function (item) {
        item.addEventListener('click', function () {
          if (isMobile()) return;
          if (item.classList.contains('gs-item--main')) return;
          activate();
          var mainItem = wrap.querySelector('.gs-item--main');
          var mainImg  = mainItem ? mainItem.querySelector('img') : null;
          var clickImg = item.querySelector('img');
          if (!mainImg || !clickImg) return;

          var tmp = {
            src:    mainImg.src,
            srcset: mainImg.getAttribute('srcset') || '',
            alt:    mainImg.alt
          };
          mainImg.src = clickImg.src;
          var cs = clickImg.getAttribute('srcset');
          if (cs) mainImg.setAttribute('srcset', cs); else mainImg.removeAttribute('srcset');
          mainImg.alt = clickImg.alt;

          clickImg.src = tmp.src;
          if (tmp.srcset) clickImg.setAttribute('srcset', tmp.srcset); else clickImg.removeAttribute('srcset');
          clickImg.alt = tmp.alt;

          allItems.forEach(function (i) { i.classList.remove('gs-grid-active'); });
          item.classList.add('gs-grid-active');
        });
      });

      /* Default first gallery as keyboard-active */
      if (!activeNavigate) activeNavigate = navigate;
    });

    /* One global keyboard listener for all gallery stacks */
    if (activeNavigate) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  activeNavigate(-1);
        if (e.key === 'ArrowRight') activeNavigate(1);
      });
    }
  }

  /* ── Section Video Lazy-Load (play autoplay videos only when entering viewport) ──
     Prevents 2-5 MB of video data loading on page open. ── */
  function initSectionVideos() {
    var selector = '.demo-image-wrap video, .result-card-media video';
    var videos = document.querySelectorAll(selector);
    if (!videos.length) return;

    if (!window.IntersectionObserver) {
      /* Fallback for old browsers — play immediately */
      videos.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var v = e.target;
          if (v.readyState === 0) v.load();
          v.play().catch(function () {});
          io.unobserve(v);
        }
      });
    }, { rootMargin: '150px' });

    videos.forEach(function (v) { io.observe(v); });
  }

  /* ── Exercise Tabs (from exercises.liquid) ── */
  function initExerciseTabs() {
    var section = document.getElementById('exercices');
    if (!section) return;
    var tabs      = Array.from(section.querySelectorAll('.ex-tab'));
    var panels    = Array.from(section.querySelectorAll('.ex-panel'));
    var total     = tabs.length;
    if (!total) return;

    function activate(idx) {
      idx = Math.max(0, Math.min(idx, total - 1));
      tabs.forEach(function(t, i) {
        t.classList.toggle('active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      panels.forEach(function(p, i) { p.classList.toggle('active', i === idx); });
      if (tabs[idx]) tabs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    tabs.forEach(function(tab, i) { tab.addEventListener('click', function() { activate(i); }); });

    var tx = 0;
    var panelsWrap = section.querySelector('.ex-panels');
    if (!panelsWrap) return;
    panelsWrap.addEventListener('touchstart', function(e) {
      tx = e.touches[0].clientX;
    }, { passive: true });
    panelsWrap.addEventListener('touchend', function(e) {
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        var activeTab = section.querySelector('.ex-tab.active');
        var cur = activeTab ? parseInt(activeTab.dataset.tab) : 0;
        activate(diff > 0 ? cur + 1 : cur - 1);
      }
    }, { passive: true });
  }

  /* ── Product Gallery Home (from product-gallery-home.liquid) ── */
  function initProductGalleryHome() {
    var gallery = document.getElementById('pgh-gallery');
    if (!gallery) return;

    var track     = document.getElementById('pgh-track');
    var dThumbs   = Array.from(gallery.querySelectorAll('.pg-thumb'));
    var prevBtn   = gallery.querySelector('.pg-prev');
    var nextBtn   = gallery.querySelector('.pg-next');
    var counterEl = document.getElementById('pgh-current');
    var total     = dThumbs.length;
    var current   = 0;

    if (!track || total === 0) return;

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (counterEl) counterEl.textContent = current + 1;
      dThumbs.forEach(function(t, i) {
        t.classList.toggle('active', i === current);
        if (i === current) t.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    dThumbs.forEach(function(t, i) { t.addEventListener('click', function() { goTo(i); }); });
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    var tx = 0, ty = 0, swiping = false;
    track.addEventListener('touchstart', function(e) {
      tx = e.touches[0].clientX; ty = e.touches[0].clientY; swiping = true;
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      if (!swiping) return;
      if (Math.abs(e.touches[0].clientX - tx) > Math.abs(e.touches[0].clientY - ty) + 8) e.preventDefault();
    }, { passive: false });
    track.addEventListener('touchend', function(e) {
      if (!swiping) return;
      swiping = false;
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 38) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });

    goTo(0);
  }

  /* ── Offer Mini Reviews Slider (from offer.liquid) ── */
  function initOfferMiniReviews() {
    document.querySelectorAll('.offer-mini-reviews').forEach(function(wrap) {
      var omrTrack = wrap.querySelector('.omr-track');
      var dots     = wrap.querySelectorAll('.omr-dot');
      var prevBtn  = wrap.querySelector('.omr-prev');
      var nextBtn  = wrap.querySelector('.omr-next');
      var total    = dots.length;
      var current  = 0;
      var timer;

      if (!omrTrack || !total) return;

      function goTo(idx) {
        current = (idx + total) % total;
        omrTrack.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function(d, i) { d.classList.toggle('active', i === current); });
      }
      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }
      function startAuto() { timer = setInterval(next, 4500); }
      function stopAuto()  { clearInterval(timer); }

      if (prevBtn) prevBtn.addEventListener('click', function() { stopAuto(); prev(); startAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { stopAuto(); next(); startAuto(); });
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() { stopAuto(); goTo(+dot.dataset.index); startAuto(); });
      });

      var tx = 0;
      omrTrack.addEventListener('touchstart', function(e) { tx = e.touches[0].clientX; }, { passive: true });
      omrTrack.addEventListener('touchend', function(e) {
        var diff = tx - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { stopAuto(); diff > 0 ? next() : prev(); startAuto(); }
      }, { passive: true });

      startAuto();
    });
  }

  /* ── Reviews Section: Voir plus + Mobile Carousel (from reviews.liquid) ── */
  function initReviewsSection() {
    /* "Voir plus" button */
    document.querySelectorAll('[data-rv-grid]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var gridId = btn.dataset.rvGrid;
        var grid = document.getElementById(gridId);
        if (!grid) return;
        var hidden = grid.querySelectorAll('.rv-extra');
        hidden.forEach(function(card, i) {
          card.classList.remove('rv-extra');
          card.style.animationDelay = (i * 60) + 'ms';
          card.classList.add('rv-fadein');
        });
        var moreWrap = btn.closest('.rv-more-wrap');
        if (moreWrap) moreWrap.style.display = 'none';
      });
    });

    /* Mobile carousel — narrow screens only */
    if (window.innerWidth > 600) return;
    var grid = document.querySelector('.reviews-grid');
    if (!grid) return;

    var moreWrap = grid.parentNode.querySelector('.rv-more-wrap');
    if (moreWrap) moreWrap.style.display = 'none';

    var cards = Array.from(grid.querySelectorAll('.review-card:not(.rv-extra)'));
    var total = cards.length;
    if (total < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'rv-carousel-wrap';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);
    grid.classList.add('rv-carousel');

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'rv-carousel-dots';
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.className = 'rv-carousel-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Avis ' + (i + 1));
      dot.dataset.idx = i;
      dotsWrap.appendChild(dot);
    }
    wrap.appendChild(dotsWrap);

    var current = 0;
    var timer;

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      grid.style.transform = 'translateX(-' + (current * 100) + '%)';
      dotsWrap.querySelectorAll('.rv-carousel-dot').forEach(function(d, i) {
        d.classList.toggle('active', i === current);
      });
    }
    function next() { goTo(current + 1); }
    function startAuto() { timer = setInterval(next, 4200); }
    function stopAuto()  { clearInterval(timer); }

    dotsWrap.addEventListener('click', function(e) {
      var dot = e.target.closest('.rv-carousel-dot');
      if (!dot) return;
      stopAuto(); goTo(+dot.dataset.idx); startAuto();
    });

    var tx = 0;
    grid.addEventListener('touchstart', function(e) {
      tx = e.touches[0].clientX; stopAuto();
    }, { passive: true });
    grid.addEventListener('touchend', function(e) {
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 38) { diff > 0 ? next() : goTo(current - 1); }
      startAuto();
    }, { passive: true });

    startAuto();
  }

  /* ── UGC Carousel + Modal (from ugc-carousel.liquid) ── */
  function initUGCSections() {
    document.querySelectorAll('[data-ugc-section]').forEach(function(sectionEl) {
      var SECTION_ID = sectionEl.dataset.ugcSection;
      var modal      = document.querySelector('[data-ugc-modal="' + SECTION_ID + '"]');
      if (!modal) return;

      var viewport = sectionEl.querySelector('[data-ugc-viewport]');
      var ugcTrack = sectionEl.querySelector('[data-ugc-track]');
      var prevBtn  = sectionEl.querySelector('[data-ugc-prev]');
      var nextBtn  = sectionEl.querySelector('[data-ugc-next]');
      var cards    = sectionEl.querySelectorAll('.ugc-card');
      if (!cards.length) return;

      /* ── Carousel scroll ── */
      var offset = 0;
      var isDragging = false, dragStartX = 0, dragStartOffset = 0, didDrag = false;

      function cardStep() {
        var c = cards[0]; if (!c) return 200;
        var gap = parseFloat(window.getComputedStyle(ugcTrack).gap) || 14;
        return c.offsetWidth + gap;
      }
      function maxOffset() { return Math.max(0, ugcTrack.scrollWidth - viewport.offsetWidth); }
      function setOffset(val, instant) {
        offset = Math.max(0, Math.min(val, maxOffset()));
        ugcTrack.style.transition = instant ? 'none' : 'transform 0.45s cubic-bezier(0.25,0.46,0.45,0.94)';
        ugcTrack.style.transform  = 'translateX(-' + offset + 'px)';
        refreshArrows();
      }
      function refreshArrows() {
        var mx = maxOffset();
        if (prevBtn) prevBtn.classList.toggle('ugc-nav--hidden', offset <= 2);
        if (nextBtn) nextBtn.classList.toggle('ugc-nav--hidden', offset >= mx - 2);
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { setOffset(offset - cardStep() * 3); });
      if (nextBtn) nextBtn.addEventListener('click', function() { setOffset(offset + cardStep() * 3); });

      if (viewport) {
        viewport.addEventListener('mousedown', function(e) {
          if (window.innerWidth <= 767 || e.button !== 0) return;
          isDragging = true; didDrag = false;
          dragStartX = e.clientX; dragStartOffset = offset;
          viewport.classList.add('ugc-dragging');
          e.preventDefault();
        });
        document.addEventListener('mousemove', function(e) {
          if (!isDragging) return;
          var dx = dragStartX - e.clientX;
          if (Math.abs(dx) > 5) didDrag = true;
          setOffset(dragStartOffset + dx, true);
        });
        document.addEventListener('mouseup', function() {
          if (!isDragging) return;
          isDragging = false;
          viewport.classList.remove('ugc-dragging');
        });
      }

      refreshArrows();
      window.addEventListener('resize', function() { setOffset(offset, true); refreshArrows(); });

      /* ── Modal ── */
      var videoEl  = modal.querySelector('[data-ugc-video]');
      var soundBtn = modal.querySelector('[data-ugc-sound]');
      var closeBtn = modal.querySelector('[data-ugc-close]');
      var mPrev    = modal.querySelector('[data-ugc-modal-prev]');
      var mNext    = modal.querySelector('[data-ugc-modal-next]');
      var nameEl   = modal.querySelector('[data-ugc-modal-name]');
      var starsEl  = modal.querySelector('[data-ugc-modal-stars]');
      var quoteEl  = modal.querySelector('[data-ugc-modal-quote]');
      var currentIdx = 0;

      var cardData = [];
      cards.forEach(function(c) {
        cardData.push({
          video: c.dataset.video  || '',
          name:  c.dataset.name   || '',
          stars: parseInt(c.dataset.stars) || 5,
          quote: c.dataset.quote  || ''
        });
      });

      function openModal(idx) {
        currentIdx = ((idx % cardData.length) + cardData.length) % cardData.length;
        loadVideo(currentIdx); updateMeta(currentIdx);
        modal.classList.add('ugc-modal--open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function closeModal() {
        modal.classList.remove('ugc-modal--open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (videoEl) { videoEl.pause(); videoEl.removeAttribute('src'); videoEl.load(); }
      }
      function loadVideo(idx) {
        var d = cardData[idx];
        if (!videoEl) return;
        if (d.video) {
          videoEl.src = d.video; videoEl.muted = true;
          var p = videoEl.play();
          if (p && typeof p.catch === 'function') p.catch(function(){});
        } else { videoEl.removeAttribute('src'); videoEl.load(); }
        updateSoundIcon();
      }
      function updateMeta(idx) {
        var d = cardData[idx];
        if (nameEl)  nameEl.textContent  = d.name;
        if (quoteEl) quoteEl.textContent = d.quote ? '"' + d.quote + '"' : '';
        if (starsEl) starsEl.textContent = '★'.repeat(Math.max(1, d.stars));
      }
      function updateSoundIcon() {
        if (!soundBtn || !videoEl) return;
        var muted = soundBtn.querySelector('.ugc-ic-muted');
        var sound = soundBtn.querySelector('.ugc-ic-sound');
        if (muted) muted.style.display = videoEl.muted ? '' : 'none';
        if (sound) sound.style.display = videoEl.muted ? 'none' : '';
      }

      cards.forEach(function(c) {
        c.addEventListener('click', function() {
          if (didDrag) { didDrag = false; return; }
          openModal(parseInt(c.dataset.index));
        });
        c.addEventListener('touchend', function(e) {
          if (e.cancelable) e.preventDefault();
          openModal(parseInt(c.dataset.index));
        });
      });

      if (soundBtn) soundBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (videoEl) { videoEl.muted = !videoEl.muted; updateSoundIcon(); }
      });
      if (closeBtn) closeBtn.addEventListener('click', function(e) { e.stopPropagation(); closeModal(); });

      modal.addEventListener('click', function(e) {
        if (window.innerWidth > 767 &&
            (e.target === modal || e.target === modal.querySelector('.ugc-modal-inner'))) {
          closeModal();
        }
      });
      document.addEventListener('keydown', function(e) {
        if (!modal.classList.contains('ugc-modal--open')) return;
        if (e.key === 'Escape')     closeModal();
        if (e.key === 'ArrowLeft')  openModal(currentIdx - 1);
        if (e.key === 'ArrowRight') openModal(currentIdx + 1);
      });
      if (mPrev) mPrev.addEventListener('click', function(e) { e.stopPropagation(); openModal(currentIdx - 1); });
      if (mNext) mNext.addEventListener('click', function(e) { e.stopPropagation(); openModal(currentIdx + 1); });

      var tStartX = 0, tStartY = 0;
      modal.addEventListener('touchstart', function(e) {
        tStartX = e.touches[0].clientX; tStartY = e.touches[0].clientY;
      }, { passive: true });
      modal.addEventListener('touchend', function(e) {
        var dx = tStartX - e.changedTouches[0].clientX;
        var dy = tStartY - e.changedTouches[0].clientY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 48) {
          dx > 0 ? openModal(currentIdx + 1) : openModal(currentIdx - 1);
        }
      }, { passive: true });
    });
  }

  /* ── Init All ── */
  function init() {
    initFAQ();
    initCountdown();
    initMobileMenu();
    initStickyHeader();
    initStickyCTA();
    initReveal();
    initAddToCart();
    initOfferCTA();
    initGallery();
    initVariants();
    initNewsletter();
    initSmoothScroll();
    initCartPage();
    initGalleryStacks();    /* Consolidated gallery — replaces inline section scripts */
    initSectionVideos();    /* Lazy-load section videos — major bandwidth saving */
    initExerciseTabs();     /* Tabs — from exercises.liquid */
    initProductGalleryHome(); /* Gallery home — from product-gallery-home.liquid */
    initOfferMiniReviews(); /* Mini slider — from offer.liquid */
    initReviewsSection();   /* Voir plus + mobile carousel — from reviews.liquid */
    initUGCSections();      /* UGC carousel + modal — from ugc-carousel.liquid */

    /* Defer cart fetch until browser is idle — not on critical path */
    if (window.requestIdleCallback) {
      requestIdleCallback(fetchCart);
    } else {
      setTimeout(fetchCart, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
